module.exports = __webpack_public_path__ + "static/media/institute-11-min.5d6163c8.webp";